import {createSlice} from "@reduxjs/toolkit";
import {IUserProfileState} from "../../interfaces";

export const reducerName = "userProfile";
export const initialState: IUserProfileState = {
    userId: 0,
    id: 0,
    firstName: "",
    lastName: "",
    image: "",
    summary: "",
    practiceCode: "",
    locationTimeZone: "",
    workingStates: [],
    averageRating: 0,
    type: "",
    address: {},
    stateOfResidence: "",
};

const profileReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setUserProfile: (state, action) => action.payload,
        setProfileImageLink: (state, action) => ({
            ...state,
            image: action.payload
        }),
        setAddress: (state, action) => ({
            ...state,
            address: action.payload
        }),
        setUserName: (state, action) => ({
            ...state,
            firstName: action.payload.firstName,
            lastName: action.payload.lastName,
        }),
    }
});

export default profileReducer.reducer;
export const {
    setUserProfile,
    setProfileImageLink,
    setAddress,
    setUserName
} = profileReducer.actions;
